import EinladungService from "../../Einladung/EinladungService";
import BerechtigungUtil from "../../../services/BerechtigungUtil";
import {html} from "@isceco/widget-library2/external/lit";
import GPEinladungDto from "../../Einladung/GPEinladungDto";
import Navigation from "../../Navigation/Navigation";
import VNBDashboardColumns from "./VNBDashboardColumns";
import BerechtigteListService from "../../../services/BerechtigteListService";
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/DateFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '../../../components/SingleDateFilter/SingleDateFilter.js'
import WebComponent from "../../../WebComponent";

export default class VNBDashboardOffeneEinladungen extends WebComponent {

  constructor() {
    super();
    this.einladungService = new EinladungService('vnb', new BerechtigungUtil().getActiveProfile().vnbExtId)
  }

  get translationFile() {
    return './views/Dashboard/VNB/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.einladungService.list('listStatus'),
      this.einladungService.getBackendListUrl('gp')
    ]).then(([statusList, offeneGPEinladungenUrl]) => {
      this.statusList = statusList.map(status => ({value: status, name: this.i18n.translate('status.' + status.toLowerCase())}))
      this.offeneGPEinladungenUrl = offeneGPEinladungenUrl
      this.render()
    })
  }

  getTemplate() {
    return html`
        <isceco-title id="page-title" text="${this.i18n.translate('dashboard.vnb.offene.einladungen')}"></isceco-title>
        <isceco-filter-group>
          <isceco-string-filter label="${this.i18n.translate('dashboard.vnb.filter.empfaenger')}"
                                key="empfaenger"
                                minchars="3"
          ></isceco-string-filter>
          <eko-single-date-filter
            label="${this.i18n.translate('dashboard.vnb.filter.date')}"
            key="valid"
          ></eko-single-date-filter>
          <isceco-multiselect-filter label="${this.i18n.translate('dashboard.vnb.filter.status')}"
                                     key="status"
                                     .items="${this.statusList}"
          ></isceco-multiselect-filter>
        </isceco-filter-group>
        <isceco-list url="${this.offeneGPEinladungenUrl}"
                     .i18n="${this.i18n}"
                     .listService="${BerechtigteListService}"
                     .dtoMapper="${this._toEinladungDTO}"
                     .columns="${VNBDashboardColumns.getColumns()}"
                     .rowurl="${this._toGPUrl}"
                     sort="empfaenger"
                     order="asc"
        ></isceco-list>`
  }

  _toEinladungDTO = row => new GPEinladungDto(row)
  _toGPUrl = row => constructURL({to: Navigation.ROUTES.gpBenutzer.url, id: row.gpExtId})

}
customElements.define('eko-frontend-vnb-dashboard-offene-einladungen', VNBDashboardOffeneEinladungen)
